<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'FORM_POSTPROCESSORS', url: '/admin/form-postprocessors' },
    { label: 'CREATE_FORM_POSTPROCESSOR' }
  ]"
></breadcrumbs>

<page-header title="CREATE_FORM_POSTPROCESSOR"></page-header>

<form-postprocessor-builder
  [isLoading]="isLoading"
  (onSubmit)="onSubmit($event)"
></form-postprocessor-builder>
